module.exports = __webpack_public_path__ + "img/omars.9fb7703f.jpg";